import { CurrentUser } from "../CoreContext"

export const userIsAdmin = (currentUser: CurrentUser) => {
  if (currentUser.type === "anon") return false
  if (currentUser.currentUser.roles.split(" ").includes("admin")) {
    return true
  }
  return false
}
